<template>
    <div>
        <h1>This is an Individual Sightings page</h1>
        <div class="sighting">
            <template v-if="!isLoading">
                <div class="sightings-sighting" v-bind="sighting">
                    <p>
                        Sighting Date: {{ sighting.sightingDate }}<br />
                        Created Date: {{ sighting.createDate }}<br />
                        Project/Species: {{ sighting.species }}<br />
                        Project/Group: {{ sighting.projectGroupName }}<br />
                        Project/Report: {{ sighting.projectReportName }}<br />
                        <span v-if="sighting.additionalProjects.length">
                            Additional Projects:
                        </span>
                        <br v-if="sighting.additionalProjects.length" />
                        <span v-if="sighting.additionalProjects.length">
                            <ul>
                                <li
                                    v-for="project in sighting.additionalProjects"
                                    v-bind:key="project"
                                >
                                    {{ project }}
                                </li>
                            </ul>
                        </span>
                        <br v-if="sighting.additionalProjects.length" />
                        Latitude/Longitude: {{ sighting.latitude }},
                        {{ sighting.longitude }}<br />
                        Location: {{ sighting.nearest }},
                        {{ sighting.nearestst }}
                        <br v-if="sighting.number > 0" />
                        <span v-if="sighting.number > 0">
                            Number: {{ sighting.number }}
                        </span>
                        <br
                            v-if="
                                sighting.duration &&
                                    sighting.duration != '00:00:00'
                            "
                        />
                        <span
                            v-if="
                                sighting.duration &&
                                    sighting.duration != '00:00:00'
                            "
                        >
                            Duration (Daylight): {{ sighting.duration }}
                        </span>
                        <br
                            v-if="
                                sighting.numberDuration &&
                                    sighting.numberDuration != '00:00:00'
                            "
                        />
                        <span
                            v-if="
                                sighting.numberDuration &&
                                    sighting.numberDuration != '00:00:00'
                            "
                        >
                            Duration (Number Sighted):
                            {{ sighting.numberDuration }}
                        </span>
                    </p>
                    <img
                        v-if="
                            sighting.sightingUrl.length &&
                                sighting.imageApproved == 'y'
                        "
                        :src="sighting.imageUrl"
                        alt="photo"
                    />
                    <img
                        v-else-if="
                            sighting.sightingUrl.length &&
                                sighting.imageApproved == 'n'
                        "
                        src="https://s3.us-east-2.amazonaws.com/journeynorth.org/images/imageshtml/image_placeholder.jpg"
                        alt="photo"
                    />
                </div>
            </template>
            <p v-else>
                Loading sighting
            </p>
            <div id="sighting-map"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import L from 'leaflet-providers'

export default {
    data() {
        return {
            isLoading: true,
            id: 0,
            sighting: null,
            latitude: 0,
            longitude: 0,
            map: null
        }
    },
    created() {
        this.id = this.$route.params.id
        axios
            .get(process.env.VUE_APP_API_DOMAIN + '/sighting/' + this.id)
            .then(({ data }) => {
                this.sighting = data.sighting
                this.latitude = data.sighting.latitude
                this.longitude = data.sighting.longitude
                this.isLoading = false
                this.initMap()
                this.initLayers()
            })
    },
    methods: {
        initMap() {
            this.map = L.map('sighting-map', {
                zoom: 5,
                maxZoom: 12,
                center: [this.latitude, this.longitude],
                renderer: L.canvas(),
                zoomControl: true,
                scrollWheelZoom: false
            })

            // L.tileLayer.provider('OpenTopoMap').addTo(this.map)
            L.tileLayer.provider('Esri.WorldTopoMap').addTo(this.map)

            var icon = L.icon({
                iconUrl: require('../assets/leaflet/marker-icon-2x-red.png'),
                iconSize: [25, 41],
                iconAnchor: [12, 41]
            })

            let marker = L.marker([this.latitude, this.longitude], {
                icon: icon,
                title: 'Sighting'
            })

            marker.addTo(this.map)
        },
        initLayers() {}
    }
}
</script>

<style type="text/css">
#sighting-map {
    background: gray;
    height: 400px;
    margin-top: 1em;
    margin-right: auto;
    margin-left: auto;
    position: relative;
    width: 100%;
    z-index: 8;
}
</style>
